export const MAX_IMAGE_BYTES = 10 * 1024 * 1024; // 10MB
export const MAX_IMAGES_PER_ITEM = 5;
export const ALLOWED_IMAGE_MIME = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

/** Returnerer en fejlbesked hvis filen er ugyldig, ellers null. */
export function validateImageFile(file: File): string | null {
  if (!ALLOWED_IMAGE_MIME.includes(file.type)) {
    return 'Ugyldigt billedformat. Brug JPG, PNG, GIF eller WEBP.';
  }
  if (file.size > MAX_IMAGE_BYTES) {
    return 'Billedet er for stort (maks. 10 MB).';
  }
  return null;
}
